module.exports = __webpack_public_path__ + "img/kontakt_1920.caeab719.png";